/* Vehicle collection pilot. Market-aware index; at most 24 rendered cards per page. */
(() => {
  'use strict';
  const root = document.querySelector('[data-vc-root]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const one = selector => root.querySelector(selector);
  const all = selector => Array.from(root.querySelectorAll(selector));
  let initial, labels;
  try { initial = JSON.parse(one('[data-vc-initial]').textContent); labels = JSON.parse(one('[data-vc-labels]').textContent); } catch (_) { return; }
  const form = one('[data-vc-form]'), grid = one('[data-vc-grid]'), pager = one('[data-vc-pager]');
  if (!form || !grid || !pager) return;
  const names = ['config', 'material', 'color', 'table', 'stock'];
  const vehicleOptions = one('[data-vc-vehicle-options]');
  if (vehicleOptions) names.unshift('vehicle');
  let inputs = all('input[type=checkbox]');
  const sorts = all('[data-vc-sort]');
  const quick = all('[data-vc-config]');
  const sortValues = ['best-selling', 'price-ascending', 'price-descending', 'title-ascending'];
  const min = one('[name=fc_min]'), max = one('[name=fc_max]');
  const count = one('[data-vc-count]'), chips = one('[data-vc-active]');
  const filters = one('.vc-filters'), results = one('.vc-results');
  const mobile = window.matchMedia('(max-width: 989px)');
  const cache = new Map(all('[data-vc-card]').map(el => [el.dataset.id, el]));
  const stockOrder = {in: 0, order: 1, out: 2};
  let records = [], ready = false, busy = false, page = 1, priceTimer, sortValue = 'best-selling';
  let collator, money;
  try { collator = new Intl.Collator(root.dataset.locale, {numeric: true, sensitivity: 'base'}); } catch (_) { collator = new Intl.Collator('nl'); }
  try { money = new Intl.NumberFormat(root.dataset.locale, {style:'currency', currency:root.dataset.currency || 'EUR'}); } catch (_) { money = new Intl.NumberFormat('nl', {style:'currency', currency:'EUR'}); }
  const text = key => labels[key] || key;
  const make = (tag, className, content) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (content !== undefined) el.textContent = content;
    return el;
  };
  const safeUrl = (value, local = false) => {
    try { const url = new URL(value, location.href); return /^https?:$/.test(url.protocol) && (!local || url.origin === location.origin) ? url.href : ''; } catch (_) { return ''; }
  };
  const cardFor = item => {
    if (cache.has(item.id)) return cache.get(item.id);
    const el = make('li','vc-card'); el.dataset.vcCard = ''; el.dataset.id = item.id; el.dataset.stock = item.stock;
    const href = safeUrl(item.url, true) || '#';
    const imageLink = make('a','vc-image'); imageLink.href = href; imageLink.setAttribute('aria-label',item.title);
    if (item.image && safeUrl(item.image)) {
      const img = make('img'); img.src = safeUrl(item.image); img.alt = item.title; img.loading = 'lazy'; img.decoding = 'async'; img.width = 720; img.height = 828; imageLink.append(img);
    }
    if (item.stock === 'out') imageLink.append(make('span','vc-badge',text('out')));
    const body = make('div','vc-content');
    const h = make('h2','vc-title'), a = make('a','',item.label); a.href = href; h.append(a); body.append(h);
    if (item.vehicle) body.append(make('p','vc-vehicle',item.vehicle));
    const specs = make('ul','vc-specs');
    // Accept text and <strong> only from our same-origin, Liquid-generated specification list.
    const parsed = new DOMParser().parseFromString('<ul>' + (item.specs || '') + '</ul>','text/html');
    parsed.querySelectorAll('ul > li').forEach(source => {
      const li = make('li',source.classList.contains('vc-code') ? 'vc-code' : '');
      if (source.firstElementChild && source.firstElementChild.tagName === 'STRONG') li.append(make('strong','',source.textContent));
      else li.textContent = source.textContent;
      specs.append(li);
    });
    body.append(specs);
    const footer = make('div','vc-footer');
    const price = make('p','vc-price');
    price.textContent = new DOMParser().parseFromString(item.priceText || '', 'text/html').body.textContent;
    footer.append(price,make('p','vc-stock',item.stockText));
    const cta = make('a','vc-action',item.action); cta.href = href; footer.append(cta); body.append(footer); el.append(imageLink,body);
    cache.set(item.id,el); return el;
  };
  const number = input => input && input.value.trim() !== '' && Number.isFinite(Number(input.value)) ? Number(input.value) : null;
  const pricesValid = report => {
    max.setCustomValidity('');
    if (number(min) !== null && number(max) !== null && number(min) > number(max)) max.setCustomValidity(text('price_error'));
    const valid = min.checkValidity() && max.checkValidity();
    if (!valid && report) form.reportValidity();
    return valid;
  };
  const readState = () => {
    const state = {min:number(min),max:number(max),sort:sortValue};
    names.forEach(name => { state[name] = inputs.filter(el => el.name === 'fc_' + name && el.checked).map(el => el.value); });
    return state;
  };
  const matches = (item,state,except) => {
    const prices = Array.isArray(item.prices) && item.prices.length ? item.prices : [item.price];
    if (!prices.some(price => (state.min === null || price >= Math.round(state.min * 100)) && (state.max === null || price <= Math.round(state.max * 100)))) return false;
    return names.every(name => name === except || !state[name].length || state[name].includes(item[name]));
  };
  const normalizeTable = announce => {
    const selected = inputs.filter(el => el.name === 'fc_config' && el.checked).map(el => el.value);
    const incompatible = selected.length === 1 && selected[0] === '11';
    const applicable = records.some(item => item.config === '12' && ['met','zonder'].includes(item.table));
    const group = one('[data-vc-group=table]');
    if (!group) return;
    group.hidden = incompatible || !applicable;
    if (group.hidden) {
      const chosen = inputs.filter(el => el.name === 'fc_table' && el.checked);
      chosen.forEach(el => { el.checked = false; });
      if (chosen.length && announce) one('[data-vc-announcement]').textContent = text('cleared_table');
    }
  };
  const urlFor = (state, targetPage) => {
    const url = new URL(location.href);
    [...names.map(name => 'fc_' + name),'fc_min','fc_max','fc_sort','fc_page','page','sort_by'].forEach(key => url.searchParams.delete(key));
    Array.from(url.searchParams.keys()).filter(key => key.startsWith('filter.')).forEach(key => url.searchParams.delete(key));
    names.forEach(name => state[name].forEach(value => url.searchParams.append('fc_' + name,value)));
    if (state.min !== null) url.searchParams.set('fc_min',String(state.min));
    if (state.max !== null) url.searchParams.set('fc_max',String(state.max));
    if (state.sort !== 'best-selling') url.searchParams.set('fc_sort',state.sort);
    if (targetPage > 1) url.searchParams.set('page',String(targetPage));
    return url;
  };
  const restore = () => {
    const p = new URL(location.href).searchParams;
    inputs.forEach(el => { el.checked = p.getAll(el.name).includes(el.value); });
    [min,max].forEach(el => {
      const raw = p.get(el.name), value = raw === null || raw.trim() === '' ? NaN : Number(raw.replace(',','.'));
      el.value = Number.isFinite(value) && value >= 0 ? String(value) : '';
    });
    if (!pricesValid(false)) { min.value = ''; max.value = ''; max.setCustomValidity(''); }
    const s = p.get('fc_sort') || p.get('sort_by'); sortValue = sortValues.includes(s) ? s : 'best-selling';
    sorts.forEach(el => { el.value = sortValue; });
    const requested = Number(p.get('page') || p.get('fc_page') || '1');
    page = Number.isSafeInteger(requested) && requested > 0 ? requested : 1;
  };
  const focusResults = () => { count.focus({preventScroll:true}); results.scrollIntoView({block:'start',behavior:'auto'}); };
  const addChip = (label, remove) => {
    const button = make('button','vc-chip',label + ' ×'); button.type = 'button'; button.setAttribute('aria-label',text('remove') + ': ' + label);
    button.addEventListener('click',() => { remove(); update(true); (chips.querySelector('button') || count).focus({preventScroll:true}); }); chips.append(button);
  };
  const updateChoices = state => {
    inputs.forEach(input => {
      const name = input.name.slice(3);
      const prospective = name === 'config' && input.value === '11' ? {...state,table:[]} : state;
      const amount = records.filter(item => matches(item,prospective,name) && item[name] === input.value).length;
      input.disabled = !input.checked && amount === 0;
      const label = input.closest('label'); label.querySelector('[data-vc-filter-count]').textContent = String(amount); label.classList.toggle('vc-unavailable',input.disabled);
    });
    names.forEach(name => {
      const group = one('[data-vc-group=' + name + ']');
      if (!group) return;
      if (name !== 'table') group.hidden = !records.some(item => inputs.some(el => el.name === 'fc_' + name && el.value === item[name]));
    });
    quick.forEach(button => {
      const value = button.dataset.vcConfig;
      const prospective = value === '11' ? {...state,table:[]} : state;
      const amount = records.filter(item => matches(item,prospective,'config') && (!value || item.config === value)).length;
      button.hidden = Boolean(value) && !records.some(item => item.config === value);
      button.disabled = amount === 0 && Boolean(value) && !state.config.includes(value);
      button.setAttribute('aria-pressed',String(value ? state.config.length === 1 && state.config[0] === value : state.config.length === 0));
      button.querySelector('[data-vc-quick-count]').textContent = '(' + amount + ')';
    });
    chips.replaceChildren();
    inputs.filter(el => el.checked).forEach(el => addChip(el.dataset.label || el.value,() => { el.checked = false; }));
    if (state.min !== null || state.max !== null) {
      const label = state.min !== null && state.max !== null ? money.format(state.min) + ' – ' + money.format(state.max) : state.min !== null ? text('from') + ' ' + money.format(state.min) : text('to') + ' ' + money.format(state.max);
      addChip(label,() => { min.value = ''; max.value = ''; });
    }
    chips.hidden = !chips.childElementCount;
    one('[data-vc-mobile-count]').textContent = chips.childElementCount ? ' (' + chips.childElementCount + ')' : '';
  };
  const renderPager = (state,totalPages) => {
    pager.replaceChildren(); pager.hidden = totalPages <= 1;
    if (totalPages <= 1) return;
    const control = (label,target,disabled,current) => {
      const el = make(disabled || current ? 'span' : 'a','vc-page',label);
      if (disabled) el.setAttribute('aria-disabled','true');
      if (current) el.setAttribute('aria-current','page');
      if (Number.isInteger(target) && target > 0) el.setAttribute('aria-label',text('page') + ' ' + target + (current ? ', ' + text('current') : ''));
      if (!disabled && !current) {
        el.href = urlFor(state,target).href;
        el.addEventListener('click',event => {
          if (event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault(); clearTimeout(priceTimer); page = target; update(true,true); focusResults();
        });
      }
      pager.append(el);
    };
    control(text('previous'),page - 1,page === 1,false);
    const pages = [...new Set([1,totalPages,page-2,page-1,page,page+1,page+2].filter(n => n >= 1 && n <= totalPages))].sort((a,b) => a-b);
    pages.forEach((n,i) => { if (i && n - pages[i-1] > 1) pager.append(make('span','vc-ellipsis','…')); control(String(n),n,false,n === page); });
    control(text('next'),page + 1,page === totalPages,false);
  };
  function update(write = false, keepPage = false) {
    if (!ready || !pricesValid(false)) return;
    if (!keepPage) page = 1;
    normalizeTable(write);
    const state = readState();
    const filtered = records.filter(item => matches(item,state)).sort((a,b) => {
      const stock = (stockOrder[a.stock] ?? 2) - (stockOrder[b.stock] ?? 2);
      if (stock) return stock;
      let order = 0;
      if (state.sort === 'price-ascending') order = a.price-b.price;
      else if (state.sort === 'price-descending') order = b.price-a.price;
      else if (state.sort === 'title-ascending') order = collator.compare(a.label,b.label);
      else order = a.rank-b.rank;
      return order || a.rank-b.rank || a.id.localeCompare(b.id);
    });
    const total = filtered.length, pages = Math.max(1,Math.ceil(total / 24)); page = Math.min(page,pages);
    const start = (page-1)*24;
    grid.replaceChildren(...filtered.slice(start,start+24).map(cardFor));
    count.textContent = pages > 1 ? (start+1) + '–' + Math.min(start+24,total) + ' ' + text('of') + ' ' + total + ' ' + text('products') : total + ' ' + text(total === 1 ? 'product' : 'products');
    one('[data-vc-empty]').hidden = total !== 0;
    updateChoices(state); renderPager(state,pages);
    const url = urlFor(state,page);
    if (url.href !== location.href) history[write ? 'pushState' : 'replaceState'](history.state,'',url);
    root.dispatchEvent(new CustomEvent('vehicle-collection:change',{bubbles:true,detail:{count:total,page,config:state.config.slice(),sort:state.sort}}));
  }
  function reset() {
    inputs.forEach(el => { el.checked = false; }); min.value = ''; max.value = ''; max.setCustomValidity(''); sortValue = 'best-selling'; sorts.forEach(el => { el.value = sortValue; }); update(true);
  }
  form.addEventListener('submit',event => { event.preventDefault(); if (pricesValid(true)) update(true); });
  form.addEventListener('change',event => { if (!event.target.matches('[data-vc-sort]') && pricesValid(true)) update(true); });
  [min,max].forEach(input => input.addEventListener('input',() => { clearTimeout(priceTimer); priceTimer = setTimeout(() => update(true),250); }));
  sorts.forEach(select => select.addEventListener('change',() => { sortValue = select.value; sorts.forEach(other => { other.value = sortValue; }); update(true); }));
  quick.forEach(button => button.addEventListener('click',() => {
    inputs.filter(el => el.name === 'fc_config').forEach(el => { el.checked = Boolean(button.dataset.vcConfig) && el.value === button.dataset.vcConfig; }); update(true);
  }));
  all('[data-vc-reset]').forEach(button => button.addEventListener('click',reset));
  window.addEventListener('popstate',() => { restore(); update(false,true); });
  const disclosure = () => { filters.open = !mobile.matches; };
  disclosure(); if (mobile.addEventListener) mobile.addEventListener('change',disclosure); else mobile.addListener(disclosure);
  filters.addEventListener('toggle',() => one('[data-vc-open]').setAttribute('aria-expanded',String(filters.open)));
  one('[data-vc-open]').addEventListener('click',() => { filters.open = true; filters.scrollIntoView({block:'start',behavior:'auto'}); filters.querySelector('summary').focus({preventScroll:true}); });
  one('[data-vc-apply]').addEventListener('click',() => { if (!pricesValid(true)) return; update(true); filters.open = false; focusResults(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => { one('[data-vc-mobile-bar]').hidden = !entries[0].isIntersecting || !ready; }).observe(root);
  }
  const validateIndex = data => {
    if (!data || !Array.isArray(data.products) || !Number.isInteger(data.pages) || data.pages < 0 || !Number.isInteger(data.page)) throw new Error('Invalid index');
    data.products.forEach(item => { if (!item.id || typeof item.url !== 'string' || !Number.isFinite(item.price) || !Number.isFinite(item.rank)) throw new Error('Invalid product'); });
    return data;
  };
  const fetchIndex = async n => {
    const url = new URL(location.href);
    Array.from(url.searchParams.keys()).filter(key => key.startsWith('fc_') || key.startsWith('filter.') || ['page','sort_by','section_id','sections'].includes(key)).forEach(key => url.searchParams.delete(key));
    url.hash = ''; url.searchParams.set('section_id','vc-index'); url.searchParams.set('sort_by','best-selling'); url.searchParams.set('page',String(n));
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(),20000);
    try {
      const response = await fetch(url.href,{credentials:'same-origin',signal:controller.signal});
      if (!response.ok) throw new Error('Index unavailable');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const script = doc.querySelector('[data-vc-index]'); if (!script) throw new Error('Missing index');
      const data = validateIndex(JSON.parse(script.textContent)); if (data.page !== n) throw new Error('Index page mismatch'); return data;
    } finally { clearTimeout(timeout); }
  };
  async function load() {
    if (busy) return; busy = true; one('[data-vc-error]').hidden = true; one('[data-vc-loading]').hidden = false;
    try {
      validateIndex(initial);
      let data = initial;
      if (initial.pages > 1 || initial.page !== 1 || root.dataset.sourceSort !== 'best-selling' || root.dataset.nativeFiltered === 'true') data = await fetchIndex(1);
      const gathered = data.products.slice();
      for (let n = 2; n <= data.pages; n++) { const next = await fetchIndex(n); if (next.total !== data.total || next.pages !== data.pages) throw new Error('Collection changed'); gathered.push(...next.products); }
      const unique = new Map(gathered.map(item => [String(item.id),item]));
      if (unique.size !== gathered.length) throw new Error('Duplicate index record');
      records = Array.from(unique.values());
      // Opt-in model/year filtering, used by mixed-model camper collections only.
      if (vehicleOptions) {
        vehicleOptions.replaceChildren();
        [...new Set(records.map(item => item.vehicle).filter(Boolean))].sort(collator.compare).forEach(vehicle => {
          const label = make('label'), input = make('input');
          input.type = 'checkbox'; input.name = 'fc_vehicle'; input.value = vehicle; input.dataset.label = vehicle;
          const amount = make('span'); amount.dataset.vcFilterCount = '';
          label.append(input,make('span','',vehicle),amount); vehicleOptions.append(label);
        });
        inputs = all('input[type=checkbox]');
      }
      delete root.dataset.loadError; ready = true; root.dataset.ready = 'true';
      all('button[disabled],input[disabled],select[disabled]').forEach(el => { el.disabled = false; });
      restore(); update(false,true); one('[data-vc-mobile-bar]').hidden = false;
    } catch (error) {
      root.dataset.loadError = 'true'; one('[data-vc-error]').hidden = false;
    } finally { busy = false; one('[data-vc-loading]').hidden = true; }
  }
  one('[data-vc-retry]').addEventListener('click',load);
  load();
})();
